import { inject, Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router } from '@angular/router'
import { Observable, of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'

import { HuntPackageRecord, Profile } from '@cyborg-monorepo/hunter/common'

import { UserService } from '../../services'
import { HuntPackageService } from '../../services/hunt-package.service'

@Injectable()
export class HuntPackageTrialResolver {
  private router = inject(Router)
  private huntPackageService = inject(HuntPackageService)
  private userService = inject(UserService)

  private readonly TRIAL_GATE_ROUTE = '/trial-gate'
  private readonly NOT_FOUND_ROUTE = '/404'

  resolve(route: ActivatedRouteSnapshot): Observable<HuntPackageRecord | null> {
    const uuid = route.paramMap.get('hunt_package_uuid')

    if (!uuid) {
      void this.router.navigate([this.NOT_FOUND_ROUTE])
      return of(null)
    }

    return this.userService.loadProfile().pipe(
      switchMap((user) => {
        if (!user) {
          void this.router.navigate([this.TRIAL_GATE_ROUTE])
          return of(null)
        }

        return this.huntPackageService.getHuntPackageByUUID(uuid).pipe(
          map((huntPackage) => {
            if (this.huntPackageIsAccessible(huntPackage, user)) {
              return huntPackage
            } else {
              void this.router.navigate([this.TRIAL_GATE_ROUTE])
              return null
            }
          }),
          catchError(() => {
            void this.router.navigate([this.NOT_FOUND_ROUTE])
            return of(null)
          }),
        )
      }),
    )
  }

  private huntPackageIsAccessible(
    huntPackage: HuntPackageRecord,
    user: Profile,
  ): boolean {
    return this.huntPackageService.huntPackageIsAccessibleForUser(
      huntPackage,
      user,
    )
  }
}
